var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 899.41 207.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#191919;}.cls-2{fill:#e544ff;}.cls-3{fill:#a34bb5;}.cls-4{fill:#e2e2e2;}.cls-5{fill:#b5b5b5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.25,80.24H297.31V74.53h50.48v5.71H325.85V137h-6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M415.15,74.53V137h-6.51V108.15H369.58V137H363V74.53h6.6v27.83h39.06V74.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M477.27,131.25V137H433.13V74.53h42.81v5.71H439.73v22.2H472v5.62H439.73v23.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M769.65,120.28H734.87L727.38,137h-6.87l28.54-62.43h6.51L784.09,137h-7Zm-2.41-5.35-15-33.53-15,33.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M841,95.93c0,13.29-9.63,21.32-25.5,21.32H801V137h-6.6V74.53h21C831.33,74.53,841,82.56,841,95.93Zm-6.6,0c0-10-6.6-15.69-19.08-15.69H801v31.21h14.25C827.76,111.45,834.36,105.74,834.36,95.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M899.41,95.93c0,13.29-9.63,21.32-25.5,21.32H859.48V137h-6.6V74.53h21C889.78,74.53,899.41,82.56,899.41,95.93Zm-6.59,0c0-10-6.6-15.69-19.09-15.69H859.48v31.21h14.25C886.22,111.45,892.82,105.74,892.82,95.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M591.25,121.92c0,15.8-16.59,29.46-41.77,29.46-13.25,0-28.85-6.35-37.55-13.18l7.5-13.53c6.69,5.62,19.21,11.58,29.79,11.58,12.45,0,24.49-5.49,24.49-14.2,0-8.43-6.16-13.92-20.35-13.92h-8.57V96.21L566.08,70.9h-49.6V56.31h70.89V68L564.61,95C582.28,97.28,591.25,107.86,591.25,121.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M607,56.31h36.3c30.4,0,51.15,18.74,51.15,46.86S673.69,150,643.29,150H607Zm35.5,79c20.89,0,34.41-12.72,34.41-32.14S663.38,71,642.49,71H624.4v64.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "236.29 60.98 130.34 0 130.34 70.94 174.66 96.45 236.29 60.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "74.48 96.45 118.8 70.94 118.8 0 12.85 60.98 74.48 96.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "118.8 207.69 0 139.31 0 68.38 118.8 136.75 118.8 207.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "249.14 68.38 130.34 136.75 130.34 207.69 249.14 139.31 249.14 68.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.63,157.35c0,3.43-2.72,7-7.93,10l-10.26,5.92V153.43l9.69-5.59c5-2.87,7.51-2.27,7.51.82a9.14,9.14,0,0,1-2.64,5.88C165.21,154,166.63,154.86,166.63,157.35ZM153,154.25v4.68l4.56-2.64C159.8,155,161,153.5,161,152s-1.22-1.62-3.46-.33Zm9,5.28c0-1.67-1.27-1.73-3.65-.35L153,162.27v4.9l5.36-3.09C160.74,162.7,162,161.23,162,159.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.86,146.24v3.68l-15.35,8.87V139l15-8.65V134l-10.42,6v4.3l9.2-5.31v3.57l-9.2,5.31v4.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M200,127.39l-6.35,3.66v-3.74l17.28-10v3.74l-6.34,3.66v16.09L200,143.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M228.88,122.57l-9.2,5.31-1.76,5.26-4.7,2.72,8.84-24.93,4.53-2.62L235.45,123l-4.81,2.78Zm-1.44-2.65-3.15-5.78-3.14,9.41Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7c9b62bbc32779d17e065f1e16a309c1.svg";
export { ForwardRef as ReactComponent };